<app-header></app-header>

<div class="usecases-page">
  <!-- Asset header: breadcrumbs, title, description -->
  <section class="usecases-page--header-wrap" aria-label="Use Cases page header">
    <app-asset-header [config]="headerConfig"></app-asset-header>
  </section>

  <!-- New design: AI Application cards (no detail page) -->
  <div class="usecases-page--main">
    <div class="usecases-page--container">
      <div class="usecases-page--list" *ngIf="aiApplications.length > 0">
        <article
          *ngFor="let app of aiApplications; trackBy: trackById"
          class="ai-app-card"
          [id]="'usecase-' + app.id"
          tabindex="0"
          appInView
        >
          <div class="ai-app-card--header">
            <div class="ai-app-card--title-block">
              <h2 class="ai-app-card--title">{{ app.title }}</h2>
            </div>
            <div class="ai-app-card--header-actions">
              <div class="ai-app-card--icon-wrap" [class.ai-app-card--icon-wrap--dark]="app.iconKey === 'seed' && !app.iconPath" [attr.aria-hidden]="true">
                <!-- Icon from public/usecase folder when iconPath is set (static JSON) -->
                <img *ngIf="app.iconPath" [src]="app.iconPath" class="ai-app-card--icon-img" alt="" />
                <ng-container *ngIf="!app.iconPath" [ngSwitch]="app.iconKey">
                  <img *ngSwitchCase="'seed'" class="ai-app-card--icon-img" src="/usecase/seed.png" alt="" />
                  <img *ngSwitchCase="'pest'" class="ai-app-card--icon-img" src="/usecase/pest.png" alt="" />
                  <!-- Pest & disease identification – beetle with prohibition/cross-out -->
                  <svg *ngSwitchCase="'pest-disease'" class="ai-app-card--icon-svg ai-app-card--icon-pest-disease" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <ellipse cx="12" cy="11" rx="5" ry="6"/>
                    <path d="M7 8c-1.5 1-2.5 3-2.5 5s1 4 2.5 5M17 8c1.5 1 2.5 3 2.5 5s-1 4-2.5 5"/>
                    <path d="M4 11h2M18 11h2M12 4v2M12 18v2"/>
                    <path d="M8 14h.01M12 14h.01M16 14h.01"/>
                    <circle cx="12" cy="12" r="9" class="ai-app-card--icon-prohibition"/>
                    <path d="M7.5 7.5l9 9M16.5 7.5l-9 9" class="ai-app-card--icon-prohibition"/>
                  </svg>
                  <!-- Custom fertiliser blending -->
                  <svg *ngSwitchCase="'fertiliser'" class="ai-app-card--icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9 3h6v4H9zM10 7h4v12H10zM8 19h8"/>
                    <path d="M12 11v4M10 15h4"/>
                    <path d="M12 7c0-1 .5-2 2-2v0"/>
                  </svg>
                  <!-- Harvest / sugarcane -->
                  <svg *ngSwitchCase="'harvest'" class="ai-app-card--icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 22V8M12 8L8 4M12 8l4-4"/>
                    <path d="M12 8v14M9 14h6M8 18h8"/>
                    <path d="M12 12l-1.5 3h3L12 12z"/>
                  </svg>
                  <!-- Farm gate logistics -->
                  <svg *ngSwitchCase="'logistics'" class="ai-app-card--icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 22c4-2 6-5 6-10S16 4 12 2 6 5 6 10s2 8 6 10z"/>
                    <path d="M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>
                    <path d="M8 11l2 2 4-4"/>
                  </svg>
                  <!-- Default -->
                  <svg *ngSwitchDefault class="ai-app-card--icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                    <path d="M2 17l10 5 10-5"/>
                  </svg>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="ai-app-card--value-section">
            <span class="ai-app-card--section-label">How It Creates Value</span>
            <p class="ai-app-card--section-content" appOverflowScroll>{{ app.howItCreatesValue }}</p>
          </div>
          <div class="ai-app-card--section">
            <span class="ai-app-card--section-label">Datasets Required</span>
            <div class="ai-app-card--chips ai-app-card--chips-inline" *ngIf="getChips(app.datasetsRequired).length > 0">
              <span class="ai-app-card--chip" *ngFor="let item of getChips(app.datasetsRequired) | slice:0:datasetsVisibleLimit">{{ item }}</span>
              <button type="button" class="ai-app-card--view-more" *ngIf="getChips(app.datasetsRequired).length > datasetsVisibleLimit" (click)="openDatasetsModal(app.title, getChips(app.datasetsRequired))">View more</button>
            </div>
            <p class="ai-app-card--section-content ai-app-card--section-content--muted" *ngIf="getChips(app.datasetsRequired).length === 0">{{ app.datasetsRequired === '—' || !app.datasetsRequired ? 'Not specified' : app.datasetsRequired }}</p>
          </div>
          <div class="ai-app-card--section">
            <span class="ai-app-card--section-label">Primary Beneficiaries</span>
            <div class="ai-app-card--section-row">
              <div class="ai-app-card--chips" *ngIf="getChips(app.primaryBeneficiaries).length > 0">
                <span class="ai-app-card--chip" *ngFor="let item of getChips(app.primaryBeneficiaries)">{{ item }}</span>
              </div>
              <p class="ai-app-card--section-content ai-app-card--section-content--muted" *ngIf="getChips(app.primaryBeneficiaries).length === 0">{{ app.primaryBeneficiaries === '—' || !app.primaryBeneficiaries ? 'Not specified' : app.primaryBeneficiaries }}</p>
              <!-- Share feature: commented out for now. Uncomment to re-enable.
              <app-card-share-button
                *ngIf="app.id"
                [title]="app.title"
                [path]="'/usecases#usecase-' + app.id"
                kind="Use case"
              ></app-card-share-button>
              -->
            </div>
          </div>
        </article>
      </div>
      <div class="usecases-page--empty" *ngIf="!loading && aiApplications.length === 0">
        <p>No AI applications to display.</p>
      </div>
      <div class="usecases-page--loading" *ngIf="loading">
        <p>Loading usecases…</p>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>

<!-- Login Modal -->
<app-login-modal *ngIf="showLoginModal" (visibleChange)="showLoginModal = false"></app-login-modal>

<!-- Datasets Required – View more modal -->
<app-modal
  [(visible)]="datasetsModalVisible"
  header=""
  width="480px"
  styleClass="custom-modal datasets-modal"
  [showHeader]="true"
  [showFooter]="false"
  (visibleChange)="datasetsModalVisible = $event"
>
  <div class="datasets-modal--chips">
    <span class="ai-app-card--chip" *ngFor="let item of datasetsModalItems">{{ item }}</span>
  </div>
</app-modal>

<!-- ========== COMMENTED: previous catalogue layout (asset header + filter + content) ==========
<app-asset-listing-page
  [headerConfig]="headerConfig"
  [filterConfig]="filterConfig"
  [assets]="usecases"
  assetType="usecase"
  searchPlaceholder="Search for usecases"
  filterSearchPlaceholder="Search for usecases"
  [searchQuery]="searchQuery"
  [currentPage]="currentPage"
  [totalPages]="totalPages"
  [viewMode]="viewMode"
  [itemsPerPage]="itemsPerPage"
  [showMobileFilterButton]="true"
  [isMobileFilterOpen]="isMobileFilterOpen"
  [isLoggedIn]="isLoggedIn"
  (filterChange)="onFilterChange($event)"
  (resetFilters)="onResetFilters()"
  (searchChange)="onSearchChange($event)"
  (pageChange)="onPageChange($event)"
  (viewModeChange)="onViewModeChange($event)"
  (itemsPerPageChange)="onItemsPerPageChange($event)"
  (openMobileFilter)="openMobileFilter()"
  (closeMobileFilter)="closeMobileFilter()"
  [sortOption]="sortOption"
  (sortChange)="onSortChange($event)"
  (bookmarksClick)="onBookmarksClick()"
  (likeClick)="onLikeClick()"
></app-asset-listing-page>
========== -->
